/**
 * Open-Iti Imports business service
 */
angular.module("open-iti").factory("OpenPublicationService", ["$http", "ENV", function ($http, ENV) {


	/**
	 * API
	 */
	var api = {
		postPublication: postPublication,
		getPublications: getPublications,
		deletePublication: deletePublication,
		putSettings: putSettings,
		getSettingsPublications: getSettingsPublications
	};


	/**
	 * Envoyer une nouvelle publication.
	 * @param publicationData
	 * @returns {*|HttpPromise}
	 */
	function postPublication(publicationData) {

		var fd = new FormData();
		fd.append("network", publicationData.currentNetwork);
		fd.append("lines", publicationData.linesString);
		fd.append("exports", publicationData.formats);
		fd.append("name", publicationData.nameNetworkSelected);
		fd.append("publishedgoogle", publicationData.publicationGoogle);
		fd.append("typeLicence", publicationData.typeLicence);
		fd.append("fileLicence", publicationData.fileLicence);

		return $http.post(ENV.API_URL + "/open-data/publications", fd, {
			transformRequest: angular.identity,
			headers: {"Content-Type": undefined}
		});

	}

	function getSettingsPublications() {
		return $http.get(ENV.API_URL + "/open-data/settings");
	}


	function getPublications() {
		return $http.get(ENV.API_URL + "/open-data/publications");
	}

	function deletePublication(publicationToDelete) {
		return $http.delete(ENV.API_URL + "/open-data/publications/" + publicationToDelete.id);
	}

	function putSettings(informations) {
		var fd = new FormData();
		fd.append("name", informations.name);
		fd.append("phone", informations.phone);
		fd.append("email", informations.email);
		fd.append("address", informations.address);
		fd.append("termsSales", informations.termsSales);
		fd.append("termsTransport", informations.termsTransport);
		fd.append("informationAgencies", informations.informationAgencies);
		fd.append("activeFormPublic", informations.activeFormPublic);

		if (informations.logo !== undefined) {
			fd.append("logo", informations.logo);
		}
		if (informations.background !== undefined) {
			fd.append("background", informations.background);
		}
		if (informations.activeNewsletter !== undefined) {
			fd.append("activeNewsletter", informations.activeNewsletter);
		}
		if (informations.mainColor !== undefined) {
			fd.append("mainColor", informations.mainColor);
		}
		if (informations.secondaryColor !== undefined) {
			fd.append("secondaryColor", informations.secondaryColor);
		}

		return $http.put(ENV.API_URL + "/open-data/settings", fd, {
			transformRequest: angular.identity,
			headers: {"Content-Type": undefined}
		});
	}

	return api;
}]);
